import { useEffect } from 'react';
import { post } from '../utils/ajax';
import { remoteRoutes } from '../data/constants';

// No WebSockets — "online" is just "pinged in the last ~3 minutes" (see
// presence.service.ts's ONLINE_WINDOW_MS), so a heartbeat every 60s while
// the app is open is enough, matching this app's existing polling style
// (useTokenRefresh, the chat unread badge).
const HEARTBEAT_INTERVAL_MS = 60 * 1000;

export function usePresenceHeartbeat(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return undefined;

    // The error callback matters more than the success one. Without it a
    // failed ping falls through to handleError, which treats a 401 as a
    // dead session and wipes storage — so a background heartbeat could log
    // someone out mid-task. A missed heartbeat is worth nothing; swallow it.
    const ping = () =>
      post(
        remoteRoutes.presenceHeartbeat,
        {},
        () => {},
        () => {},
      );

    ping();
    const interval = setInterval(ping, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [enabled]);
}
